import React from "react";
import { Box, Button, styled } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ReactComponent as WarningIcon } from "images/warning-icon.svg";

const Container = styled(Box)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "80%",
});

const AccessDeniedDuePayments = () => {
  const navigate = useNavigate();

  const isPaymentMethodPage =
    window.location.pathname.includes("payment_method");

  return (
    <Container>
      <div
        className={[
          "flex flex-col justify-between items-center gap-6",
          "bg-red-100 text-red-800 p-6 px-12 mx-6 md:mx-8 mt-2 rounded-lg text-md text-center",
        ].join(" ")}
      >
        <WarningIcon />
        Your account is currently disabled due to non-payment.
        <br />
        Please, update your payment method to continue using Referral Stream!
        {!isPaymentMethodPage && (
          <Button
            variant="contained"
            color="error"
            size="small"
            sx={{ padding: "8px 16px", boxShadow: "none" }}
            onClick={() => navigate("/payment_method")}
          >
            Update Payment Method
          </Button>
        )}
      </div>
    </Container>
  );
};

export default AccessDeniedDuePayments;
